module.exports = __webpack_public_path__ + "img/svg/explain-1.bc00a4b1c067fea09043f3657fa9b31f.svg";